import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ConfigurationsService } from './service/configurations.service';
// import { cloneDeep } from 'lodash-es';
// import { GlobalConfig ,ToastrService} from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
// import { LanguageService } from 'src/app/multi-language/language.service';
import { TfService } from 'src/app/tf/tf-service.service';
import { NavigationItem } from '../navigation/navigation';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfigurationComponent implements OnInit {
  // public props
  styleSelectorToggle: boolean; // open configuration menu
  layoutType: string; // layout type
  rtlLayout: any; // rtl type
  menuFixedLayout: any; // menu/navbar fixed flag
  headerFixedLayout: any; // header fixed flag
  boxLayout: any; // box layout flag
  isColoredIcon: boolean; // menu icon color
  headerBackgroundColor: string; // header background color
  navbarBackgroundColor: string; // navbar background color
  brandBackgroundColor: string; // brand/logo background color
  navBackgroundImage: any; // navbar background image
  menuDropdownIcon: string; // navbar background image
  menuListIcon: string; // navbar background image
  navActiveColor: string;
  navTitleColor: string;
  menuTitleHide: any;
  headerBackColor: string;
  config: any;
  isConfig: boolean;
  host = environment.apiUrlHost;
  layout: string;
  themeConfig: any;
  isAdmin;
  isStaf:boolean;
  isToggled:boolean;
  token : string
  group
   // Toast
  //  options: GlobalConfig;
  //  private lastInserted: number[] = [];
  //  type = {
  //    error: 'toast-error',
  //    info: 'toast-info',
  //    success: 'toast-success',
  //    warning: 'toast-warning'
  //  }
   navigation:any;
   items:any;

  // constructor
  constructor(private location: Location,
    private ConfigurationsService: ConfigurationsService,
    // public toastr: ToastrService,
    // public languageService: LanguageService,
    public translate: TranslateService,
    public TfService : TfService,
    public nav:NavigationItem
  ) {

      this.ConfigurationsService.getConfig().subscribe((res) => {
        this.themeConfig = res;
        this.config = this.themeConfig
        this.setThemeLayout();
      });
      this.TfService.isToggled$.subscribe((value) => {
        this.isToggled = value;
      });
      // this.token = TfService.getToken();
      // this.group = TfService.getUserGroupsFromToken(this.token)
      // this.isStaf= TfService.getUserStaffFromToken(this.token)
      // if(this.group == 'admin'){
      //   this.isAdmin = true
      // }
      // else{
      //   this.isAdmin = false
      // }
this.getListscreenCustomer();

  }

  // life cycle event
  ngOnInit() {
    this.styleSelectorToggle = false;
    this.layoutType = this.themeConfig.layout_type;
    this.setLayout(this.layoutType);
    this.isColoredIcon = this.themeConfig.isNavIconColor;
    this.changeIconColor(this.isColoredIcon);
    this.headerBackgroundColor = this.themeConfig.headerBackColor;
    this.setHeaderBackground(this.headerBackgroundColor);
    this.navbarBackgroundColor = this.themeConfig.navBackColor;
    this.setNavbarBackground(this.navbarBackgroundColor);
    this.brandBackgroundColor = this.themeConfig.navBrandColor;
    this.setBrandBackground(this.brandBackgroundColor);
    this.navBackgroundImage = this.themeConfig.navBackImage;
    this.setBackgroundImage(this.navBackgroundImage);
    this.rtlLayout = this.themeConfig.isRtlLayout;
    this.changeRtlLayout(this.rtlLayout);
    this.menuFixedLayout = this.themeConfig.isNavFixedLayout;
    if (this.themeConfig.layout === 'vertical') {
      this.changeMenuFixedLayout(this.menuFixedLayout);
    }
    this.headerFixedLayout = this.themeConfig.isHeaderFixedLayout;
    this.changeHeaderFixedLayout(this.headerFixedLayout);
    this.boxLayout = this.themeConfig.isBoxLayout;
    this.changeBoxLayout(this.boxLayout);
    this.menuDropdownIcon = this.themeConfig.navDropdownIcon;
    this.setMenuDropdownIcon(this.menuDropdownIcon);
    this.menuListIcon = this.themeConfig.navListIcon;
    this.setMenuListIcon(this.menuListIcon);
    this.navActiveColor = this.themeConfig.navActiveListColor;
    this.setNavActiveColor(this.navActiveColor);
    this.navTitleColor = this.themeConfig.navListTitleColor;
    this.setNavTitleColor(this.navTitleColor);
    this.menuTitleHide = this.themeConfig.isNavListTitleHide;
    this.changeMenuTitle(this.menuTitleHide);
  }

  sendThemeConfigToBackend() {
    // Assuming ThemeConfig is your configuration data
    const updatedConfig = {
      headerBackColor: this.headerBackgroundColor,
      layout_type: this.layoutType,
      isNavIconColor: this.isColoredIcon,
      navBackColor: this.navbarBackgroundColor,
      navBrandColor: this.brandBackgroundColor,
      navBackImage: this.navBackgroundImage,
      isRtlLayout: this.rtlLayout,
      isNavFixedLayout: this.menuFixedLayout,
      isHeaderFixedLayout: this.headerFixedLayout,
      isBoxLayout: this.boxLayout,
      navDropdownIcon: this.menuDropdownIcon,
      navListIcon: this.menuListIcon,
      navActiveListColor: this.navActiveColor,
      isNavListTitleHide: this.menuTitleHide,
    }
    this.ConfigurationsService.addConfig({config_data :updatedConfig}).subscribe((res: any) => {
      // this.openToast('cfItemCreateUpdate.successMessage', 'cfItemCreateUpdate.successTitle', this.type.success);
    },
      (error: any) => {
      // this.openToast('cfItemCreateUpdate.errorMessage', 'cfItemCreateUpdate.errorTitle', this.type.error);
      }
    );
  }

  setThemeLayout() {
    this.ngOnInit()
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }

    // different layout
    switch (current_url) {
      case this.location['_baseHref'] + '/layout/static':
        this.themeConfig.layout = 'vertical';
        this.themeConfig.isNavFixedLayout = false;
        this.themeConfig.isHeaderFixedLayout = false;
        break;
      case this.location['_baseHref'] + '/layout/fixed':
        this.themeConfig.layout = 'vertical';
        this.themeConfig.isNavFixedLayout = true;
        this.themeConfig.isHeaderFixedLayout = true;
        break;
      case this.location['_baseHref'] + '/layout/nav-fixed':
        this.themeConfig.layout = 'vertical';
        this.themeConfig.isNavFixedLayout = true;
        this.themeConfig.isHeaderFixedLayout = false;
        break;
      case this.location['_baseHref'] + '/layout/collapse-menu':
        this.themeConfig.layout = 'vertical';
        this.themeConfig.isCollapseMenu = true;
        break;
      case this.location['_baseHref'] + '/layout/horizontal':
        this.themeConfig.layout = 'horizontal';
        break;
      case this.location['_baseHref'] + '/layout/box':
        this.themeConfig.layout = 'vertical';
        this.themeConfig.isBoxLayout = true;
        this.themeConfig.isCollapseMenu = true;
        break;
      case this.location['_baseHref'] + '/layout/rtl':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.isRtlLayout = true;
        break;
      case this.location['_baseHref'] + '/layout/light':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.layout_type = 'menu-light';
        break;
      case this.location['_baseHref'] + '/layout/dark':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.layout_type = 'dark';
         this.themeConfig.navBackColor = 'navbar-dark';
         this.themeConfig.navBrandColor = 'brand-dark';
        break;
      case this.location['_baseHref'] + '/layout/icon-color':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.layout_type = 'menu-light';
         this.themeConfig.isNavIconColor = true;
        break;
      case this.location['_baseHref'] + '/layout/layout-2':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-2';
        break;
      case this.location['_baseHref'] + '/layout/layout-2-2':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-2-2';
        break;
      case this.location['_baseHref'] + '/layout/layout-3':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-3';
        break;
      case this.location['_baseHref'] + '/layout/layout-4':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-4';
        break;
      case this.location['_baseHref'] + '/layout/layout-4-2':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-4-2';
        break;
      case this.location['_baseHref'] + '/layout/layout-5h':
         this.themeConfig.layout = 'horizontal';
         this.themeConfig.layout_type = 'menu-light';
         this.themeConfig.isNavIconColor = true;
         this.themeConfig.headerBackColor = 'header-blue';
        break;
      case this.location['_baseHref'] + '/layout/nav-color':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.layout_type = 'menu-light';
         this.themeConfig.isNavIconColor = true;
         this.themeConfig.headerBackColor = 'header-lightblue';
         this.themeConfig.navBrandColor = 'brand-lightblue';
         this.themeConfig.isNavFixedLayout = true;
         this.themeConfig.isHeaderFixedLayout = true;
        break;
      case this.location['_baseHref'] + '/layout/layout-6':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-6';
         this.themeConfig.layout_type = 'menu-light';
         this.themeConfig.isNavIconColor = true;
         this.themeConfig.navBrandColor = 'brand-lightblue';
         this.themeConfig.isNavFixedLayout = false;
         this.themeConfig.isHeaderFixedLayout = false;
         this.themeConfig.layout_6_Background = '#23b7e5';
        break;
      case this.location['_baseHref'] + '/layout/layout-8':
         this.themeConfig.layout = 'vertical';
         this.themeConfig.pre_layout = 'layout-8';
         this.themeConfig.layout_type = 'menu-light';
         this.themeConfig.headerBackColor = 'header-lightblue';
         this.themeConfig.navBrandColor = 'brand-lightblue';
         this.themeConfig.isNavFixedLayout = true;
         this.themeConfig.isHeaderFixedLayout = true;
         this.themeConfig.navActiveListColor = 'active-lightblue';
        break;
      default:
        break;
    }
  }

  setPreBuildLayout(pre_layout) {
    if (pre_layout === 'layout-6') {
      document.querySelector('.pcoded-navbar').classList.add('menupos-static');
      this.headerBackColor = this.themeConfig.layout_6_Background;
      this.setHeaderBackColor(this.headerBackColor);
    }

    if (pre_layout !== 'layout-6' && pre_layout !== 'layout-8') {
      this.isConfig = false;
      document.querySelector('.pcoded-navbar').classList.add(pre_layout);
    } else {
      document.querySelector('body').classList.add(pre_layout);
    }
  }

  setHeaderBackColor(color) {
    this.headerBackColor = color;
    (document.querySelector('body') as HTMLElement).style.background = color;
  }

  // change main layout
  setLayout(layout) {
    this.isConfig = true;
    this.setNavbarBackground(this.themeConfig.navBackColor);
    this.setBrandBackground(this.themeConfig.navBrandColor);
    document.querySelector('.pcoded-navbar').classList.remove('menu-light');
    document.querySelector('.pcoded-navbar').classList.remove('menu-dark');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-dark');
    document.querySelector('.pcoded-navbar').classList.remove('brand-dark');
    document.querySelector('body').classList.remove('datta-dark');
    this.setHeaderBackground('header-default');

    this.layoutType = layout;
    if (layout === 'menu-light') {
      this.setNavbarBackground(this.navbarBackgroundColor);
      this.setBrandBackground(this.brandBackgroundColor);
      document.querySelector('.pcoded-navbar').classList.add(layout);
    }
    if (layout === 'dark') {
      document.querySelector('.pcoded-navbar').classList.add('navbar-dark');
      document.querySelector('.pcoded-navbar').classList.add('brand-dark');

      this.setNavbarBackground('navbar-dark');
      this.setBrandBackground('brand-dark');

      if (this.themeConfig.pre_layout !== 'layout-6') {
        this.setHeaderBackground('header-dark');
      }

      document.querySelector('body').classList.add('datta-dark');
    }
    if (layout === 'reset') {
      this.reset();
    }
  }

  reset() {
    document.querySelector('.pcoded-navbar').classList.remove('icon-colored');
    this.ngOnInit();
  }

  setColoredIcon(e) {
    const flag = !!e.target.checked;
    this.changeIconColor(flag);
  }

  changeIconColor(flag) {
    if (flag) {
      document.querySelector('.pcoded-navbar').classList.add('icon-colored');
    } else {
      document.querySelector('.pcoded-navbar').classList.remove('icon-colored');
    }
  }

  setRtlLayout(e) {
    const flag = !!e.target.checked;
    this.changeRtlLayout(flag);
  }

  changeRtlLayout(flag) {
    if (flag) {
      document.querySelector('body').classList.add('datta-rtl');
    } else {
      document.querySelector('body').classList.remove('datta-rtl');
    }
  }

  setMenuFixedLayout(e) {
    const flag = !!e.target.checked;
    this.changeMenuFixedLayout(flag);
  }

  changeMenuFixedLayout(flag) {
    setTimeout(() => {
      if (flag) {
        document.querySelector('.pcoded-navbar').classList.remove('menupos-static');
        // (document.querySelector('#nav-ps-datta') as HTMLElement).style.maxHeight = 'calc(100vh - 70px)';
      } else {
        document.querySelector('.pcoded-navbar').classList.add('menupos-static');
        (document.querySelector('#nav-ps-datta') as HTMLElement).style.maxHeight = '100%';
      }
    }, 100);
  }

  setHeaderFixedLayout(e) {
    const flag = !!e.target.checked;
    this.changeHeaderFixedLayout(flag);
  }

  changeHeaderFixedLayout(flag) {
    if (flag) {
      document.querySelector('.pcoded-header').classList.add('headerpos-fixed');
      document.querySelector('.pcoded-header').classList.add('header-blue');
    } else {
      document.querySelector('.pcoded-header').classList.remove('headerpos-fixed');
    }
  }

  setBoxLayout(e) {
    const flag = !!e.target.checked;
    this.changeBoxLayout(flag);
  }

  changeBoxLayout(flag) {
    if (flag) {
      document.querySelector('body').classList.add('container');
      document.querySelector('body').classList.add('box-layout');
    } else {
      document.querySelector('body').classList.remove('box-layout');
      document.querySelector('body').classList.remove('container');
    }
  }

  hideMenuTitle(e) {
    const flag = !!e.target.checked;
    this.changeMenuTitle(flag);
  }

  changeMenuTitle(flag) {
    if (flag) {
      document.querySelector('.pcoded-navbar').classList.add('caption-hide');
    } else {
      document.querySelector('.pcoded-navbar').classList.remove('caption-hide');
    }
  }

  setHeaderBackground(background) {
    this.headerBackgroundColor = background;
    document.querySelector('.pcoded-header').classList.remove('header-blue');
    document.querySelector('.pcoded-header').classList.remove('header-red');
    document.querySelector('.pcoded-header').classList.remove('header-purple');
    document.querySelector('.pcoded-header').classList.remove('header-lightblue');
    document.querySelector('.pcoded-header').classList.remove('header-dark');
    if (background !== 'header-default') {
      document.querySelector('.pcoded-header').classList.add(background);
    }
  }

  setNavbarBackground(background) {
    this.setBackgroundImage(this.themeConfig.navBackImage);
    this.navbarBackgroundColor = background;
    document.querySelector('.pcoded-navbar').classList.remove('navbar-blue');

    document.querySelector('.pcoded-navbar').classList.remove('navbar-red');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-purple');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-lightblue');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-dark');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-green');


    // add default menu brand background color
    document.querySelector('.pcoded-navbar').classList.add('brand-default');
    if (background !== 'navbar-default') {
      document.querySelector('.pcoded-navbar').classList.add(background);
    }
  }

  setBrandBackground(background) {
    this.brandBackgroundColor = background;
    document.querySelector('.pcoded-navbar').classList.remove('brand-default');
    document.querySelector('.pcoded-navbar').classList.remove('brand-blue');
    document.querySelector('.pcoded-navbar').classList.remove('brand-red');
    document.querySelector('.pcoded-navbar').classList.remove('brand-purple');
    document.querySelector('.pcoded-navbar').classList.remove('brand-lightblue');
    document.querySelector('.pcoded-navbar').classList.remove('brand-dark');
    document.querySelector('.pcoded-navbar').classList.add(background);
  }

  setBackgroundImage(image) {
    document.querySelector('.pcoded-navbar').classList.remove('navbar-image-1');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-image-2');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-image-3');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-image-4');
    document.querySelector('.pcoded-navbar').classList.remove('navbar-image-5');
    if (image) {
      this.navBackgroundImage = image;
      document.querySelector('.pcoded-navbar').classList.add(image);
    }
  }

  setMenuDropdownIcon(icon) {
    this.menuDropdownIcon = icon; // Update the property
    document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style1');
      document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style2');
      document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style3');
      if (icon !== 'style1') {
        document.querySelector('.pcoded-navbar').classList.add('drp-icon-' + icon);
      }
  }

  setMenuListIcon(icon) {
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style1');
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style2');
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style3');
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style4');
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style5');
    document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style6');
    if (icon !== 'style1') {
      document.querySelector('.pcoded-navbar').classList.add('menu-item-icon-' + icon);
    }
  }

  setNavActiveColor(style) {
    this.navActiveColor = style;
    document.querySelector('.pcoded-navbar').classList.remove('active-default');
    document.querySelector('.pcoded-navbar').classList.remove('active-blue');
    document.querySelector('.pcoded-navbar').classList.remove('active-red');
    document.querySelector('.pcoded-navbar').classList.remove('active-purple');
    document.querySelector('.pcoded-navbar').classList.remove('active-lightblue');
    document.querySelector('.pcoded-navbar').classList.remove('active-dark');
    if (style !== 'active-default') {
      document.querySelector('.pcoded-navbar').classList.add(style);
    }
  }

  setNavTitleColor(style) {
    this.navTitleColor = style;
    document.querySelector('.pcoded-navbar').classList.remove('title-default');
    document.querySelector('.pcoded-navbar').classList.remove('title-blue');
    document.querySelector('.pcoded-navbar').classList.remove('title-red');
    document.querySelector('.pcoded-navbar').classList.remove('title-purple');
    document.querySelector('.pcoded-navbar').classList.remove('title-lightblue');
    document.querySelector('.pcoded-navbar').classList.remove('title-dark');
    if (style !== 'title-default') {
      document.querySelector('.pcoded-navbar').classList.add(style);
    }
  }

  // openToast(messageKey: string, titleKey: string, type: string) {
  //   const opt = cloneDeep(this.options);
  //   // Translate title and message
  //   this.translate.get([messageKey, titleKey]).subscribe((translations) => {
  //     const toastOptions = {
  //       ...opt,
  //       closeButton: true, // Add this line to enable the close button
  //       progressBar: true, // Add this line to enable the progress bar
  //     };
  //     const inserted = this.toastr.show(
  //       translations[messageKey],
  //       translations[titleKey],
  //       toastOptions,
  //       type
  //     );
  //     if (inserted) {
  //       this.lastInserted.push(inserted.toastId);
  //     }
  //   });
  // }

  getLastSegment(url: string): string {
    const segments = url.split('/');
    return segments[segments.length - 1]; // Returns the last part of the URL
  }

//   getListscreenCustomer(){
//     this.items = this.nav.get()
//       .map(item => item.children || [])
//       .flat()
//       .filter(child => child.role === 'contact')
//       .map(contactChild => contactChild.children || [])
//       .flat()
//       .filter(child => !(child as any).hidden);
//       this.items.push({
//         id: 'UserProfile',
//         title: 'UserProfile',
//         type: 'item',
//         url: '/customer/CPCustomizeFormData/user-profile'
//       });

// }
getListscreenCustomer() {
  // Start with the base navigation items
  const navItems = this.nav.get();
  
  // Get first level children (all items under the main navigation group)
  const firstLevelItems = navItems.flatMap(item => item.children || []);
  
  // Filter to only include 'contact' role items
  const contactItems = firstLevelItems.filter(child => child.role === 'contact');
  
  // Initialize an empty array for the final items
  this.items = [];
  
  // Safely process each contact item
  contactItems.forEach(contactItem => {
    // Check if the item has children property and it's an array
    if ('children' in contactItem && 
        contactItem.children && 
        Array.isArray(contactItem.children) && 
        contactItem.children.length > 0) {
      
      // Use type assertion to tell TypeScript that children is an array of NavigationItem
      const childrenItems = contactItem.children as NavigationItem[];
      
      // Filter out hidden items
      const visibleChildren = childrenItems.filter(subChild => !subChild.hidden);
      
      // Add visible children to the items list
      this.items.push(...visibleChildren);
    }
  });

  // Add the user profile item
  this.items.push({
    id: 'UserProfile',
    title: 'UserProfile',
    type: 'item',
    url: '/customer/CPCustomizeFormData/user-profile'
  });
}
}
